require('../../modules/es.array.find');

var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'find');